// Example for LibraryAdmin page
export const smartDogTourSteps = [
    {
      target: "#libraryAccordion", // CSS selector for the element
      content: "This page allows you to upload medical, dental and any documents related to the well-being of your dogs",
    },
    {
      target: "#libraryAccordion", // CSS selector for the element
      content: "Each registered dog will have a seperate folder for documents.",
    },
    {
      target: "#libraryAccordion", // CSS selector for the element
      content: "Under each dog add a sub folder relating to the types of records you want to keep on file.",
    },
    {
      target: "#file-listing", // Tag input field
      content: "Shows recent files listed or a specific pet folder from the sidebar.",
    },
    {
      target: "#dogFolder", // Tag input field
      content: "Choose your Dog.",
    },
    {
      target: "#subFolder", // Tag input field
      content: "Choose your sub folder for the records to be added to.",
    },
    {
      target: "#fileName", // Tag input field
      content: "Choose a file name.",
    },
    {
      target: "#fileDescription", // Tag input field
      content: "Enter a file description.",
    },
    {
      target: ".doc-uploader", // Tag input field
      content: "Choose the file to upload.",
    },
    {
      target: ".btn-primary", // Upload button
      content: "Click this button to upload your files.",
    },
  ]
  